// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"9af86071","125":"ebadaadb","457":"950f4480"}[chunkId] + ".chunk.js";
};